import $ from 'jquery';

class ReviewModal{

    constructor(){
        this.modal = null;
    }

    removeModal(){
        $('.addReviewModal').remove();
        $('body').removeClass('hideScroll');
    }

    showModal(){
        let body = $('body');
        body.append(this.modal);
        body.addClass('hideScroll');
    }

    renderModal(title){

        let self = this;

        title = title || '';

        this.removeModal();

        this.modal = $('<div class="addReviewModal">' +
            '<div class="addReviewModal__container custom-scrollbar">' +
            '<div class="addReviewModal__container-header">' +
                '<div class="addReviewModal-title">' + title +
                    '<button type="button" class="crossModal"><i class="icon-cross"></i></button>' +
                    '</div>' +
                '</div>' +
                '<div class="addReviewModal__container-body"></div>' +
            '</div>' +
            '<div class="addReviewModal__overlay"></div>' +
        '</div>');

        this.modal.find('.addReviewModal__overlay').on('click', function(){
            self.removeModal();
        })

        this.modal.find('.crossModal').on('click', function(){
            self.removeModal();
        })

        return this.modal;

    }

    addBody(body){

        this.modal.find('.addReviewModal__container-body').append(body);

    }

}

export default ReviewModal;